import { PaperClipIcon } from "@heroicons/react/20/solid";
import React from "react";

export const Attachments = ({ attachments }) => {
  const safeAttachments = Array.isArray(attachments) ? attachments : [];
  const visibleAttachments = safeAttachments.slice(0, 5);
  const remainingCount = Math.max(0, safeAttachments.length - visibleAttachments.length);

  return (
    <div className="w-full min-w-0 rounded-xl border border-wa-border bg-wa-panel2/70 p-4 sm:p-6 sm:col-span-2">
      <div className="mb-1 text-center text-lg font-semibold text-wa-text">
        Documenten
      </div>
      <div className="mb-3 text-center text-xs text-wa-muted">
        {safeAttachments.length} bestand(en) beschikbaar
      </div>
      <ul
        role="list"
        className="divide-y divide-wa-border overflow-hidden rounded-lg border border-wa-border bg-wa-panel"
      >
        {visibleAttachments.map((attachment, index) => (
          <li
            key={`${attachment?.bestand || "bestand"}-${index}`}
            className="flex items-center justify-between gap-2 py-3 pl-3 pr-3 text-sm sm:pr-4"
          >
            <div className="flex min-w-0 flex-1 items-center">
              <PaperClipIcon
                aria-hidden="true"
                className="h-5 w-5 flex-shrink-0 text-wa-accent"
              />
              <span className="ml-2 min-w-0 flex-1 truncate text-wa-text">
                <span className="font-semibold">{attachment?.title}</span> (
                {attachment?.bestand})
              </span>
            </div>
            <div className="flex-shrink-0">
              <a
                href={attachment?.url}
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-sky-400 hover:text-sky-300"
              >
                Download
              </a>
            </div>
          </li>
        ))}
        {remainingCount > 0 ? (
          <li className="py-2 text-center text-xs font-medium text-wa-muted">
            meer ... (+{remainingCount})
          </li>
        ) : null}
      </ul>
    </div>
  );
};
